import { Locales } from '../types'
import brokerCrm from './messagesBrokerCrm'
import clientPortal from './messagesClientPortal'
import defaultMessages from './messagesDefault'
import introducers from './messagesIntroducers'

export type Product = 'broker-crm' | 'client-portal' | 'introducers'

export default (product: Product, locale: Locales) => {
  let messages: { [key in Locales]: any } = { [Locales.GB]: {} }
  switch (product) {
    case 'broker-crm':
      messages = brokerCrm
      break
    case 'client-portal':
      messages = clientPortal
      break
    case 'introducers':
      messages = introducers
      break
  }
  return { ...defaultMessages[locale], ...messages[locale] }
}
